declare global {
  interface Window {
    _howxm?: (...args: unknown[]) => void
    _howxmQueue?: unknown[]
  }
}

export interface HowxmUserContext {
  id: string
  username?: string
  email?: string
  realName?: string
  tenantId?: string
  tenantName?: string
  branchId?: string
  branchName?: string
}

/** 用户详情中浩客 identify 所需字段（租户端/客户端接口统一字段名） */
export interface HowxmUserDetailLike {
  tenantId?: string | number
  tenantName?: string
  branchId?: string | number
  branchName?: string
}

export interface HowxmIdentifyExtras {
  tenantId?: string
  tenantName?: string
  branchId?: string
  branchName?: string
}

/**
 * 从用户详情接口构建 identify 扩展字段（用户 / 租户 / 分公司）
 * @param detail 用户详情
 */
export function buildHowxmIdentifyExtras(
  detail?: HowxmUserDetailLike | null
): HowxmIdentifyExtras {
  if (!detail) {
    return {}
  }

  return {
    tenantId: detail.tenantId !== null ? String(detail.tenantId) : '',
    tenantName: detail.tenantName || '',
    branchId: detail.branchId !== null ? String(detail.branchId) : '',
    branchName: detail.branchName || ''
  }
}

/**
 * 向浩客传递用户身份信息
 * @param user 当前登录用户
 * @param extras 用户详情接口补充字段
 */
export function syncHowxmIdentify(
  user: HowxmUserContext | null | undefined,
  extras?: HowxmIdentifyExtras
): void {
  if (!user?.id || typeof window._howxm !== 'function') {
    return
  }

  window._howxm('identify', {
    uid: String(user.id),
    name: user.realName || user.username || '',
    email: user.email || '',
    tenantId: extras?.tenantId || user.tenantId || '',
    tenantName: extras?.tenantName || user.tenantName || '',
    branchId: extras?.branchId || user.branchId || '',
    branchName: extras?.branchName || user.branchName || ''
  })
}
